/**
 * Ícono de un adjunto: cuadro de color según la familia (PDF rojo, Word azul, Excel/CSV verde,
 * PowerPoint naranja, imagen morado, el resto gris) con la extensión en mayúsculas. Decorativo:
 * el nombre del archivo va escrito al lado.
 */
import type { Adjunto } from '@cdtec-backlog/contrato';
import { extensionDe, familiaDeExtension } from './previsualizacion';
import './IconoExtension.css';

export function IconoExtension({
  adjunto,
  grande = false,
}: {
  adjunto: Pick<Adjunto, 'nombre' | 'tipoMime'>;
  grande?: boolean;
}) {
  const clases = [
    'icono-ext',
    `icono-ext--${familiaDeExtension(adjunto.tipoMime)}`,
    grande ? 'icono-ext--grande' : '',
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <span className={clases} aria-hidden="true">
      {extensionDe(adjunto)}
    </span>
  );
}
